import { biLoggerFactory } from 'wix-private';
import { BIEventsIDs } from 'public/constants.js';

const biLogger = biLoggerFactory('blog-tg', 19, { msid: '05eb856c-0c11-4619-98e1-3cf524053998' });

$w.onReady(function () {
    // initPageEvents();
});

// function initPageEvents() {
//     $w('#startBloggingBtn').rendered && $w('#startBloggingBtn').onClick(() => {
//         const ctaName = $w('#startBloggingBtn').label;
//         //fire header CTA click BI event 
//         fireBIEvent(6, { ctaName });
//     });
//     //siteMenu can't fire BI evnts on it
//     $w('#titleGeneratorBox').onClick(() => {
//         const ctaName = $w('#titleGeneratorMenuBtn').label;
//         fireBIEvent(6, { ctaName });

//     });
//     $w('#articlesBox').onClick(() => {
//         const ctaName = $w('#articlesBtn').label;
//         fireBIEvent(6, { ctaName });
//     })
//     $w('#toolsBtn').onClick(() => {
//         const ctaName = $w('#toolsBtn').label;
//         fireBIEvent(6, { ctaName });
//     })

// }

async function fireBIEvent(evidIndex, params) {
    const evid = BIEventsIDs[evidIndex];
    try {
        const biEventObject = {
            evid,
            ...params
        };
        await biLogger.log(biEventObject);
        console.log("bi fired with:",biEventObject)
    } catch (err) {
        console.error(`errSrc: Public/BIEventsFunctions - fireBIEvent, err: ${err}`);
    }

}